/* LBScent - free-gift prompt.
 *
 * The prompt's Add button is a real <form> that posts to /cart/add, so it works
 * with no JavaScript at all - it just costs a page load. This upgrades it to an
 * in-drawer add using the theme's own cart-drawer rendering, so the drawer
 * stays open and the totals update in place.
 *
 * Delegated from document, because the cart drawer is replaced wholesale every
 * time the cart changes - a listener bound directly to the button would be
 * thrown away on the first update.
 */
(() => {
  const FORM = '.lbs-gift-offer__form';

  async function addGift(form) {
    const button = form.querySelector('button');
    const original = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';

    try {
      const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(form.querySelector('[name="id"]').value), quantity: 1 }],
          // Ask Shopify to re-render these alongside the add, so the drawer and
          // the header count update from one round trip.
          sections: ['cart-drawer', 'cart-icon-bubble'],
        }),
      });

      if (!res.ok) throw new Error('add failed: ' + res.status);
      const data = await res.json();

      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
        drawer.renderContents(data);
      } else {
        // Cart page, or a theme that renders the drawer differently.
        window.location.reload();
      }
    } catch (err) {
      // Fall back to the plain form post rather than leaving the customer
      // with a dead button.
      console.error('[lbs-gift-offer]', err);
      button.disabled = false;
      button.textContent = original;
      form.submit();
    }
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.closest(FORM);
    if (!form) return;
    e.preventDefault();
    addGift(form);
  });
})();
